(function ($) {
  if (!$) return;

  function exactDollars(cents) {
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  var fallbackBundlePresentations = {
    'TK6C-FBT3-BUNDLE': {
      images: [
        'https://cdn.shopify.com/s/files/1/0129/7684/8960/files/shopmainNEW_7c58b3ef-a7d1-4ee8-a919-358ece654e9f.jpg?v=1734622073',
        'https://cdn.shopify.com/s/files/1/0129/7684/8960/files/shopmain_28f3ec42-4149-4ac2-b0c5-bc7879088307.jpg?v=1740943727',
        'https://cdn.shopify.com/s/files/1/0129/7684/8960/products/210103_XOF_PDP3_0445_EDIT.jpg?v=1658791096'
      ],
      labels: ['Something Blue Socks', 'Something Blue Hat', 'That Bride Clip']
    },
    '3TMS-FBT3-BUNDLE': {
      images: [
        'https://cdn.shopify.com/s/files/1/0129/7684/8960/products/XOF_PDP_5317_EDIT-compressed.jpg?v=1640283896',
        'https://cdn.shopify.com/s/files/1/0129/7684/8960/products/XO_Fetti_1253.jpg?v=1670517414',
        'https://cdn.shopify.com/s/files/1/0129/7684/8960/products/XO_Fetti_1649_c239735d-b1a9-46d3-b131-48fb9e7fff1f.jpg?v=1673561455'
      ],
      labels: ['Same Straw Forever', 'Shimmer XL Penis', 'P3N!5 Accordions']
    },
    'EX61-FBT3-BUNDLE': {
      images: [
        'https://cdn.shopify.com/s/files/1/0129/7684/8960/products/XO_Fetti_1253.jpg?v=1670517414',
        'https://cdn.shopify.com/s/files/1/0129/7684/8960/products/XOF_PDP_5317_EDIT-compressed.jpg?v=1640283896',
        'https://cdn.shopify.com/s/files/1/0129/7684/8960/products/XO_Fetti_1213.jpg?v=1670518166'
      ],
      labels: ['Shimmer XL Penis', 'Same Straw Forever', 'Shimmer P3N!5 Curtain']
    },
    'VLH5-FBT3-BUNDLE': {
      images: [
        'https://cdn.shopify.com/s/files/1/0129/7684/8960/files/shopmain_249d5ead-afd8-492b-8132-9d65c5bf9e35.jpg?v=1742566143',
        'https://cdn.shopify.com/s/files/1/0129/7684/8960/products/XO_Fetti_1253.jpg?v=1670517414',
        'https://cdn.shopify.com/s/files/1/0129/7684/8960/products/XOF_PDP_5317_EDIT-compressed.jpg?v=1640283896'
      ],
      labels: ['Penis Confetti', 'Shimmer XL Penis', 'Same Straw Forever']
    },
    'DBA8-FBT3-BUNDLE': {
      images: [
        'https://cdn.shopify.com/s/files/1/0129/7684/8960/files/shopmainNEW_b28e88ae-b864-43f2-a614-68f75a47b329.jpg?v=1775246408',
        'https://cdn.shopify.com/s/files/1/0129/7684/8960/files/shopifymain_9485aaa8-6b2a-48c8-b3c4-22a7bb31315e.jpg?v=1709069613',
        'https://cdn.shopify.com/s/files/1/0129/7684/8960/products/Ken_xoFetti_Dimmitt-12.jpg?v=1659708120'
      ],
      labels: ['XL BRIDE Balloons', 'Bride To Be Veil', 'Iridescent Curtain']
    },
    'K255-FBT3-BUNDLE': {
      images: [
        'https://cdn.shopify.com/s/files/1/0129/7684/8960/files/shopifymain_9485aaa8-6b2a-48c8-b3c4-22a7bb31315e.jpg?v=1709069613',
        'https://cdn.shopify.com/s/files/1/0129/7684/8960/files/shopmainNEW_b28e88ae-b864-43f2-a614-68f75a47b329.jpg?v=1775246408',
        'https://cdn.shopify.com/s/files/1/0129/7684/8960/products/shopmain.jpg?v=1674619185'
      ],
      labels: ['Bride To Be Veil', 'XL BRIDE Balloons', 'That Bride Sash']
    }
  };

  function bundlePresentation(item) {
    var properties = item.properties || {};
    var images = item.xoBundleImages || String(properties._xo_bundle_images || '').split('|').filter(Boolean);
    var labels = item.xoBundleLabels || String(properties._xo_bundle_labels || '').split('|').filter(Boolean);

    if (images.length === 3) return { images: images, labels: labels };
    return fallbackBundlePresentations[item.sku] || null;
  }

  function renderBundleImages(row, presentation) {
    var imageLink = row && row.querySelector('.ajaxcart__product-image');
    if (!imageLink || !presentation || imageLink.querySelector('.xo-cart-bundle-images')) return;

    var strip = document.createElement('span');
    strip.className = 'xo-cart-bundle-images';

    presentation.images.forEach(function (src, index) {
      var image = document.createElement('img');
      image.src = src;
      image.alt = presentation.labels[index] || 'Bundle product';
      strip.appendChild(image);
    });

    imageLink.textContent = '';
    imageLink.appendChild(strip);
  }

  function renderCart(cart) {
    if (!cart || !cart.items) return;

    window.requestAnimationFrame(function () {
      cart.items.forEach(function (item, index) {
        var row = document.querySelector('.ajaxcart__row[data-line="' + (index + 1) + '"]');

        renderBundleImages(row, bundlePresentation(item));

        if (item.price % 100 !== 0) {
          var price = row && row.querySelector('.ajaxcart-item__price .money');
          if (price) price.textContent = exactDollars(item.price);
        }
      });

      if (cart.total_price % 100 !== 0) {
        var subtotal = document.querySelector('.cart_subtotal_wrapp .one-third p');
        if (subtotal) subtotal.textContent = exactDollars(cart.total_price);
      }
    });
  }

  $(document.body).on('ajaxCart.afterCartLoad.xoExactCents', function (event, cart) {
    var needsPrivateBundleData = cart && cart.items && cart.items.some(function (item) {
      return /-FBT3-BUNDLE$/i.test(item.sku || '') && !bundlePresentation(item);
    });

    if (!needsPrivateBundleData || !window.fetch) {
      renderCart(cart);
      return;
    }

    window.fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .then(renderCart)
      .catch(function () { renderCart(cart); });
  });
})(window.jQuery);

var xoCartBundleStyle = document.createElement('style');
xoCartBundleStyle.textContent =
  '.xo-cart-bundle-images{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));grid-template-rows:repeat(2,minmax(0,1fr));align-items:center;gap:3px;aspect-ratio:1;overflow:hidden;border-radius:6px}' +
  '.xo-cart-bundle-images img{display:block;width:100%!important;height:100%!important;min-width:0;aspect-ratio:1;object-fit:cover;object-position:center;border-radius:3px}' +
  '.xo-cart-bundle-images img:nth-child(3){grid-column:1/-1;justify-self:center;width:calc(50% - 1.5px)!important}' +
  '.ajaxcart__product-meta{display:block;margin-top:3px}';
document.head.appendChild(xoCartBundleStyle);
